export default {
  // 风险类型
  质量风险: "質量風險",
  交付风险: "交付風險",
  财务风险: "財務風險",
  成本风险: "成本風險",
  注册风险: "註冊風險",
  其他风险: "其他風險",

  // 风险等级
  高: "高",
  中: "中",
  低: "低",

  // Modal 标题
  通知供应商风险: "通知供應商風險",
  查看供应商风险: "查看供應商風險",
  编辑供应商风险: "編輯供應商風險",
  登记供应商风险: "登記供應商風險",

  // 表格列标题
  处理状态: "處理狀態",
  供应商编号: "供應商編號",
  "供应商名称（中文）": "供應商名稱（中文）",
  "供应商名称（英文）": "供應商名稱（英文）",
  物料类别: "物料類別",
  风险等级: "風險等級",
  发起人: "發起人",
  发起部门: "發起部門",
  发起日期: "發起日期",
  操作: "操作",

  // 状态值
  未知: "未知",

  // 操作按钮
  编辑: "編輯",
  删除: "刪除",
  查看: "查看",
  通知供应商: "通知供應商",

  // 确认对话框
  删除确认: "刪除確認",
  "确定要删除此风险等级吗？": "確定要刪除此風險等級嗎？",
  确定: "確定",
  取消: "取消",
  点击上传: "點擊上傳",

  // 搜索字段
  供应商: "供應商",
  物料: "物料",
  请输入供应商名称: "請輸入供應商名稱",
  请输入物料名称: "請輸入物料名稱",
  请选择处理状态: "請選擇處理狀態",
  请选择发起人: "請選擇發起人",

  // 物料类别选项
  电子元器件: "電子元器件",
  机械零件: "機械零件",
  化工原料: "化工原料",
  其他: "其他",

  // 风险类型选项（搜索）
  交期风险: "交期風險",
  价格风险: "價格風險",
  信用风险: "信用風險",

  // 处理状态选项
  草稿: "草稿",
  待通知供应商: "待通知供應商",
  待供应商提供解决方案: "待供應商提供解決方案",
  解决方案审批中: "解決方案審批中",
  已驳回解决方案: "已駁回解決方案",
  已完结: "已完結",

  // 列表标题和按钮
  供应商风险等级列表: "供應商風險登記列表",

  // 分页
  共数据条: "共 {{totalCount}} 筆數據",

  // 表单标签
  员工姓名: "員工姓名",
  员工工号: "員工工號",
  创建日期: "建立日期",
  部门: "部門",
  岗位: "崗位",
  邮箱: "郵箱",
  供应商信息: "供應商信息",
  请输入供应商编号搜索: "請輸入供應商編號搜尋",
  供应商名称中文: "供應商名稱中文",
  供应商名称英文: "供應商名稱英文",
  二级物料类别: "二級物料類別",
  物料编号: "物料編號",
  请输入物料编号搜索: "請輸入物料編號搜尋",
  物料名称: "物料名稱",
  风险类型: "風險類型",
  风险等级评估: "風險等級評估",
  发现日期: "發現日期",
  期望解决日期: "期望解決日期",
  风险描述: "風險描述",
  相关证明文件: "相關證明文件",
  供应商解决方案: "供應商解決方案",
  备注说明: "備註說明",
  评估信息: "評估信息",
  评估意见: "評估意見",
  意见说明: "意見說明",
  同意: "同意",
  驳回: "駁回",
  由供应商编号自动填写: "由供應商編號自動填寫",

  // 表单占位符
  请输入员工姓名: "請輸入員工姓名",
  请输入员工工号: "請輸入員工工號",
  请输入创建日期: "請輸入建立日期",
  请输入部门: "請輸入部門",
  请输入岗位: "請輸入崗位",
  请输入邮箱: "請輸入郵箱",
  请选择物料类别: "請選擇物料類別",
  请选择二级物料类别: "請選擇二級物料類別",
  请选择风险类型: "請選擇風險類型",
  请选择风险等级评估: "請選擇風險等級評估",
  请选择发现日期: "請選擇發現日期",
  请选择期望解决日期: "請選擇期望解決日期",
  请输入风险描述: "請輸入風險描述",
  请上传相关证明文件: "請上傳相關證明文件",
  请输入备注说明: "請輸入備註說明",
  请选择评估意见: "請選擇評估意見",
  请输入意见说明: "請輸入意見說明",

  // 表单验证消息
  供应商编号必填: "供應商編號必填",
  供应商名称中文必填: "供應商名稱中文必填",
  供应商名称英文必填: "供應商名稱英文必填",
  物料类别必填: "物料類別必填",
  二级物料类别必填: "二級物料類別必填",
  物料名称必填: "物料名稱必填",
  风险类型必填: "風險類型必填",
  风险等级评估必填: "風險等級評估必填",
  发现日期必填: "發現日期必填",
  期望解决日期必填: "期望解決日期必填",
  风险描述必填: "風險描述必填",
  相关证明文件必填: "相關證明文件必填",

  // 消息提示
  生成失败: "生成失敗",
  提交成功: "提交成功",
  提交失败: "提交失敗",
  已暂存: "已暫存",
  暂存失败: "暫存失敗",
  表单数据获取失败: "表單數據獲取失敗",
  已通知供应商: "已通知供應商",
  任务ID不存在无法通知供应商: "任務ID不存在無法通知供應商",
  通知供应商失败: "通知供應商失敗",
  加载风险登记详情失败: "加載風險登記詳情失敗",
  删除成功: "刪除成功",

  // 文件相关
  暂无解决方案文件: "暫無解決方案文件",

  // 数据加载错误
  获取物料数据失败: "獲取物料數據失敗",
  获取供应商数据失败: "獲取供應商數據失敗",

  // 其他
  单号: "單號",
  加载中: "加載中",

  searchFields: {
    supplier: "供應商",
    material: "物料",
    materialCategory: "物料類別",
    materialName: "物料名稱",
    riskType: "風險類型",
    processingStatus: "處理狀態",
    initiator: "發起人",
    supplierNameP: "請輸入供應商名稱",
    materialNameP: "請輸入物料名稱",
    materialCategoryP: "請選擇物料類別",
    riskTypeP: "請選擇風險類型",
    processingStatusP: "請選擇處理狀態",
    initiatorP: "請選擇發起人",
  },
};
